export const USER_DETAILS_ACTIONS = {
  SET_USER_CURRENCY: "SET_USER_CURRENCY",
};

export const setUserCurrency = (data: string) => ({
  type: USER_DETAILS_ACTIONS.SET_USER_CURRENCY,
  data,
});
